import { LDClientBase } from 'launchdarkly-js-sdk-common'
import { asyncWithLDProvider, basicLogger } from 'launchdarkly-react-client-sdk'

import { User } from 'api/types/userApiTypes'
import { defaultFeatureFlagSet } from 'hooks/feature-flags/featureFlagSet'
import { isProdEnvironment } from 'utils/environment'

import logError from './logError'

export const initializeLaunchDarkly = () =>
  asyncWithLDProvider({
    clientSideID: isProdEnvironment() ? '64f8af68b025eb123e889675' : '64f8af68b025eb123e889674',
    flags: defaultFeatureFlagSet,
    options: {
      logger: basicLogger({
        level: isProdEnvironment() ? 'none' : 'info',
      }),
    },
    context: {
      kind: 'user',
      anonymous: true,
      // Hardcoding this key ensures that our MUA user count is not incremented by every
      // anonymous user session, only by the authenticated ones identified below.
      key: 'unique-anonymous-user-key',
    },
  })

export const updateLaunchDarklyUser = async (
  { id, email, user_name }: User,
  organization: string,
  ldClient: LDClientBase
) => {
  try {
    // LaunchDarkly is designed to still operate if this call fails, so we catch the error
    // instead of rethrowing and triggering a top-level error boundary.
    // https://launchdarkly.com/blog/designing-for-failure-to-avoid-disaster/
    await ldClient.identify({
      kind: 'user',
      key: id,
      email,
      name: user_name,
      organizationName: organization,
      anonymous: false,
    })
  } catch (error) {
    logError({ message: 'Unable to update LaunchDarkly user', error })
  }
}
